export class CreateActivationCodeRequestDTO {
  constructor() {
    this.logged_in_address = null;
    this.guild_id = null;
  }
}